import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Clock, LogOut } from "lucide-react";

function fmt(s) {
  const m = Math.floor(s / 60);
  const sec = s % 60;
  return `${m}:${String(sec).padStart(2, "0")}`;
}

export function IdleWarning() {
  const { user, idleWarn, idleSeconds, stayActive, logout } = useAuth();
  if (!user || !idleWarn) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-background/90 backdrop-blur-md flex items-center justify-center p-4 scanlines" data-testid="idle-warning">
      <div className="w-full max-w-sm border border-border bg-surface">
        <div className="border-b border-border px-6 py-5 flex items-center gap-3">
          <div className="h-9 w-9 flex items-center justify-center bg-primary text-primary-foreground">
            <Clock className="h-5 w-5" strokeWidth={2.2} />
          </div>
          <div>
            <h1 className="text-sm font-semibold tracking-tight leading-none">Are you still there?</h1>
            <p className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mt-1">Inactivity Sign-out</p>
          </div>
        </div>

        <div className="px-6 py-6 space-y-4 text-center">
          <p className="text-xs text-muted-foreground">You'll be automatically signed out in</p>
          <p data-testid="idle-countdown" className="text-4xl font-mono font-semibold text-primary tabular-nums">{fmt(idleSeconds)}</p>
          <div className="flex gap-2 pt-1">
            <Button data-testid="idle-logout" onClick={logout} variant="outline" className="flex-1 rounded-none border-border text-xs">
              <LogOut className="h-4 w-4 mr-1.5" /> Log out now
            </Button>
            <Button data-testid="idle-stay" onClick={stayActive} className="flex-1 rounded-none bg-primary text-primary-foreground hover:bg-accent-hover font-medium">
              Stay signed in
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
